// Original source:
// eslint-disable-next-line no-restricted-imports
import Rollbar from 'rollbar';

export { Rollbar as Reporter };
